var data = {
	list:[
	// {
	// 	id:1,
	// 	name:'旅行救援服务',
	// 	text:'7天/15天/30天可选',
	// 	content:'赠送同期旅意险 可满足申根',
	// 	money:'39'
	// },
	{
		id:1,
		name:'留学救援服务',
		text:'保障期1年',
		content:'海外留学生专属保障',
		money:'220'
	},
	{
		id:2,
		name:'商旅救援服务',
		text:'保障期1年',
		content:'企业高管及文职人员首选',
		money:'145'
	},
	{
		id:3,
		name:'劳务外派救援服务',
		text:'保障期1年',
		content:'企业高管及文职人员首选',
		money:'480'
  },
//   {
// 		id:4,
// 		name:'境内一日游救援服务',
// 		text:'中华人民共和国境内 ',
// 		content:'（不包括港澳台）',
// 		money:'5'
//   }
]
}
export default data;


// WEBPACK FOOTER //
// ./src/views/rescuelist/js/list.js